import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import Breadcrumbs from '../components/Breadcrumbs';
import ModularBlocks from '../components/ModularBlocks';
import FeatureCategoryOverview from '../components/FeatureCategoryOverview';

const FeatureDetailTemplate = ({
  data: {
    datoCmsFeature: { seoMetaTags, title, category, modularBlocks },
    allDatoCmsFeature: { nodes },
  },
}) => (
  <Layout seo={seoMetaTags}>
    <main>
      <Breadcrumbs
        currentPageTitle={title}
        items={[
          {
            text: 'CRM',
            urlPath: 'crm',
          },
          {
            text: category.title,
            urlPath: `crm/${category.slug}`,
          },
        ]}
      />
      <Banner heading={title} />
      <ModularBlocks items={modularBlocks} />
      <FeatureCategoryOverview title="Other Features" items={nodes} />
    </main>
  </Layout>
);

export const FeatureDetailTemplateQuery = graphql`
  query FeatureDetailTemplateQuery($id: String!, $categoryId: String!) {
    datoCmsFeature(id: { eq: $id }) {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      title
      category {
        title
        slug
      }
      modularBlocks {
        ...AccordionModularBlockFragment
        ...ContainedImageModularBlockFragment
        ...ContentModularBlockFragment
        ...ExternalVideoModularBlockFragment
        ...ImageContentModularBlockV1Fragment
        ...InternalVideoModularBlockFragment
        ...TestimonialsModularBlockFragment
      }
    }
    allDatoCmsFeature(
      filter: { id: { ne: $id }, category: { id: { eq: $categoryId } } }
      sort: { position: ASC }
    ) {
      nodes {
        title
        slug
        description
        category {
          slug
          icon {
            url
            alt
          }
        }
      }
    }
  }
`;

export default FeatureDetailTemplate;
